import { render, staticRenderFns } from "./MoleculeEditionAccountProfile.vue?vue&type=template&id=5f23c674&"
import script from "./MoleculeEditionAccountProfile.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAccountProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports